(function () {
  'use strict';

  // ─── Bootstrap ───────────────────────────────────────────────────────────

  const root = document.getElementById('reservation-root');
  if (!root) return;

  const CONFIG = {
    locale:                    root.dataset.locale || 'en',
    currency:                  root.dataset.currency || 'CAD',
    maxSeats:                  parseInt(root.dataset.maxSeats, 10) || 40,
    paypalClientId:            root.dataset.paypalClientId || '',
    emailjsPublicKey:          root.dataset.emailjsPublicKey || '',
    emailjsServiceId:          root.dataset.emailjsServiceId || '',
    emailjsCustomerTemplate:   root.dataset.emailjsCustomerTemplate || '',
    emailjsRestaurantTemplate: root.dataset.emailjsRestaurantTemplate || '',
    adminApiUrl:               root.dataset.adminApiUrl || '',
    adminApiKey:               root.dataset.adminApiKey || '',
  };

  const SERVICE_FEE_RATE = 0.03;

  const CUTOFF_HOUR = 7; // Bookings close at 7 AM the day of the reservation

  // ─── Time slots ──────────────────────────────────────────────────────────

  // Weekday: 8:00 AM – 2:30 PM | Weekend (Fri/Sat): 8:00 AM – 3:00 PM
  function getTimeSlotsForDate(dateStr) {
    var weekend = isWeekend(dateStr);
    var endMinutes = weekend ? 15 * 60 : 14 * 60 + 30;
    var slots = [];
    for (var totalMin = 8 * 60; totalMin <= endMinutes; totalMin += 30) {
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      slots.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'));
    }
    return slots;
  }

  // ─── Helpers ─────────────────────────────────────────────────────────────

  function isWeekend(dateStr) {
    var d = new Date(dateStr + 'T12:00:00');
    var day = d.getDay();
    return day === 5 || day === 6; // Friday or Saturday
  }

  function getDepositAmount(partySize, dateStr) {
    if (!isWeekend(dateStr)) return 0;
    return partySize >= 10 ? 100 : 50;
  }

  /** Returns true if the cutoff (7 AM day-of) has already passed */
  function isTooSoon(dateStr) {
    if (!dateStr) return false;
    var cutoff = new Date(dateStr + 'T' + String(CUTOFF_HOUR).padStart(2, '0') + ':00:00');
    return new Date() >= cutoff;
  }

  function getServiceFee(depositAmount) {
    if (depositAmount <= 0) return 0;
    return depositAmount * SERVICE_FEE_RATE;
  }

  function fmt(price) {
    return '$' + price.toFixed(2);
  }

  function generateReservationId() {
    var now = new Date();
    var date = now.getFullYear().toString()
      + String(now.getMonth() + 1).padStart(2, '0')
      + String(now.getDate()).padStart(2, '0');
    var rand = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'CG-R' + date + '-' + rand;
  }

  // ─── DOM refs ────────────────────────────────────────────────────────────

  var dateEl    = document.getElementById('res-date');
  var timeEl    = document.getElementById('res-time');
  var partyEl   = document.getElementById('res-party');
  var nameEl    = document.getElementById('res-name');
  var emailEl   = document.getElementById('res-email');
  var phoneEl   = document.getElementById('res-phone');
  var notesEl   = document.getElementById('res-notes');

  var availEl         = document.getElementById('res-availability');
  var depositInfoEl   = document.getElementById('res-deposit-info');
  var depositAmtEl    = document.getElementById('res-deposit-amount');
  var disabledMsgEl   = document.getElementById('res-disabled-msg');
  var tooSoonMsgEl    = document.getElementById('res-too-soon-msg');
  var submitContainer = document.getElementById('res-submit-container');
  var paypalContainer = document.getElementById('res-paypal-container');
  var bookBtn         = document.getElementById('res-book-btn');

  // ─── Availability check ──────────────────────────────────────────────────

  var lastAvailability = null; // { available_seats }

  function checkAvailability() {
    var date = dateEl.value;
    var time = timeEl.value;

    if (!date || !time) {
      availEl.style.display = 'none';
      lastAvailability = null;
      updateSubmitZone();
      return;
    }

    availEl.style.display = 'block';
    availEl.className = 'res__availability res__availability--loading';
    availEl.textContent = CONFIG.locale === 'fr' ? 'Vérification de la disponibilité…' : 'Checking availability…';

    var url = CONFIG.adminApiUrl + '?date=' + encodeURIComponent(date) + '&time=' + encodeURIComponent(time);

    fetch(url, {
      headers: { 'X-API-Key': CONFIG.adminApiKey },
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        lastAvailability = data;
        renderAvailability();
        updateSubmitZone();
      })
      .catch(function () {
        availEl.className = 'res__availability res__availability--error';
        availEl.textContent = CONFIG.locale === 'fr'
          ? 'Impossible de vérifier la disponibilité. Veuillez réessayer.'
          : 'Unable to check availability. Please try again.';
        lastAvailability = null;
        updateSubmitZone();
      });
  }

  function renderAvailability() {
    if (!lastAvailability) return;

    var avail = lastAvailability.available_seats;
    var party = parseInt(partyEl.value, 10) || 0;

    if (avail <= 0) {
      availEl.className = 'res__availability res__availability--full';
      availEl.textContent = CONFIG.locale === 'fr'
        ? 'Ce créneau est complet. Veuillez choisir un autre horaire.'
        : 'This time slot is full. Please choose another time.';
    } else if (party > 0 && party > avail) {
      availEl.className = 'res__availability res__availability--insufficient';
      availEl.textContent = CONFIG.locale === 'fr'
        ? 'Seulement ' + avail + ' places disponibles pour ce créneau.'
        : 'Only ' + avail + ' seats available for this time slot.';
    } else {
      availEl.className = 'res__availability res__availability--ok';
      availEl.textContent = CONFIG.locale === 'fr'
        ? avail + ' places disponibles'
        : avail + ' seats available';
    }
  }

  // ─── Deposit display ─────────────────────────────────────────────────────

  function updateDepositInfo() {
    var date = dateEl.value;
    var party = parseInt(partyEl.value, 10) || 0;

    if (!date || party < 6) {
      depositInfoEl.style.display = 'none';
      return;
    }

    var deposit = getDepositAmount(party, date);
    if (deposit > 0) {
      depositInfoEl.style.display = 'block';
    } else {
      depositInfoEl.style.display = 'none';
    }
  }

  // ─── Form validation ─────────────────────────────────────────────────────

  function isFormValid() {
    var date  = dateEl.value;
    var time  = timeEl.value;
    var party = parseInt(partyEl.value, 10) || 0;
    var name  = nameEl.value.trim();
    var email = emailEl.value.trim();
    var phone = phoneEl.value.trim();

    var emailValid = /\S+@\S+\.\S+/.test(email);
    return date && time && party >= 6 && party <= 14 && name && emailValid && phone;
  }

  function hasAvailableSeats() {
    if (!lastAvailability) return false;
    var party = parseInt(partyEl.value, 10) || 0;
    return party > 0 && party <= lastAvailability.available_seats;
  }

  function highlightErrors() {
    ['res-date', 'res-time', 'res-party', 'res-name', 'res-email', 'res-phone'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (!el.value.trim()) {
        el.classList.add('error');
      } else {
        el.classList.remove('error');
      }
    });
  }

  // ─── Submit zone ─────────────────────────────────────────────────────────

  function updateSubmitZone() {
    var valid = isFormValid() && hasAvailableSeats();
    var date = dateEl.value;
    var time = timeEl.value;
    var party = parseInt(partyEl.value, 10) || 0;
    var deposit = getDepositAmount(party, date);
    var tooSoon = isTooSoon(date);

    // Show/hide the too-soon warning
    if (tooSoonMsgEl) tooSoonMsgEl.style.display = tooSoon ? 'block' : 'none';

    if (!valid || tooSoon) {
      disabledMsgEl.style.display = tooSoon ? 'none' : 'block';
      submitContainer.style.display = 'none';
      paypalContainer.style.display = 'none';
    } else if (deposit > 0) {
      // Weekend — PayPal deposit required
      disabledMsgEl.style.display = 'none';
      submitContainer.style.display = 'none';
      paypalContainer.style.display = 'block';
    } else {
      // Weekday — simple book button
      disabledMsgEl.style.display = 'none';
      paypalContainer.style.display = 'none';
      submitContainer.style.display = 'block';
    }
  }

  // ─── PayPal ──────────────────────────────────────────────────────────────

  function initPayPal() {
    if (!window.paypal || !CONFIG.paypalClientId) return;

    paypal.Buttons({
      style: { layout: 'vertical', color: 'gold', shape: 'rect', label: 'pay' },

      onClick: function (data, actions) {
        if (!isFormValid() || !hasAvailableSeats()) {
          highlightErrors();
          return actions.reject();
        }
        return actions.resolve();
      },

      createOrder: function (data, actions) {
        var party = parseInt(partyEl.value, 10);
        var deposit = getDepositAmount(party, dateEl.value);
        var fee = getServiceFee(deposit);
        var total = deposit + fee;

        var desc = CONFIG.locale === 'fr'
          ? 'Dépôt de réservation – Chez Greenberg'
          : 'Reservation Deposit – Chez Greenberg';

        return actions.order.create({
          purchase_units: [{
            description: desc,
            amount: {
              currency_code: CONFIG.currency,
              value: total.toFixed(2),
              breakdown: {
                item_total: { currency_code: CONFIG.currency, value: deposit.toFixed(2) },
                handling:   { currency_code: CONFIG.currency, value: fee.toFixed(2) },
              },
            },
            items: [{
              name: CONFIG.locale === 'fr' ? 'Dépôt de réservation' : 'Reservation Deposit',
              quantity: '1',
              unit_amount: { currency_code: CONFIG.currency, value: deposit.toFixed(2) },
            }],
          }],
        });
      },

      onApprove: function (data, actions) {
        return actions.order.capture().then(function (details) {
          var party = parseInt(partyEl.value, 10);
          var deposit = getDepositAmount(party, dateEl.value);
          var fee = getServiceFee(deposit);
          var resId = generateReservationId();

          submitReservation({
            resId: resId,
            depositAmount: deposit,
            serviceFee: fee,
            depositPaid: true,
            txnId: details.id,
          });
        });
      },

      onError: function (err) {
        console.error('PayPal error:', err);
        var msg = CONFIG.locale === 'fr'
          ? 'Une erreur est survenue. Veuillez réessayer.'
          : 'An error occurred. Please try again.';
        alert(msg);
      },
    }).render('#res-paypal-buttons');
  }

  // ─── Submit reservation ──────────────────────────────────────────────────

  function submitReservation(opts) {
    var resId        = opts.resId;
    var depositAmount = opts.depositAmount || 0;
    var serviceFee   = opts.serviceFee || 0;
    var depositPaid  = opts.depositPaid || false;
    var txnId        = opts.txnId || null;

    var name  = nameEl.value.trim();
    var email = emailEl.value.trim();
    var phone = phoneEl.value.trim();
    var date  = dateEl.value;
    var time  = timeEl.value;
    var party = parseInt(partyEl.value, 10);
    var notes = (notesEl.value || '').trim();

    // Send emails
    sendEmails({ resId: resId, depositAmount: depositAmount, depositPaid: depositPaid, txnId: txnId });

    // Submit to admin API
    if (CONFIG.adminApiUrl && CONFIG.adminApiKey) {
      fetch(CONFIG.adminApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': CONFIG.adminApiKey,
        },
        body: JSON.stringify({
          customer_name: name,
          customer_email: email,
          customer_phone: phone,
          party_size: party,
          reservation_date: date,
          reservation_time: time + ':00',
          notes: notes,
          deposit_amount: depositAmount,
          service_fee: serviceFee,
          deposit_paid: depositPaid,
          paypal_transaction_id: txnId,
          locale: CONFIG.locale,
        }),
      }).catch(function (err) { console.error('Admin API submit failed:', err); });
    }

    // Show success
    showSuccess({ resId: resId, depositAmount: depositAmount, serviceFee: serviceFee, depositPaid: depositPaid, txnId: txnId });
  }

  // ─── EmailJS ─────────────────────────────────────────────────────────────

  function sendEmails(opts) {
    if (!window.emailjs || !CONFIG.emailjsPublicKey || !CONFIG.emailjsServiceId) return;

    emailjs.init(CONFIG.emailjsPublicKey);

    var name  = nameEl.value.trim();
    var email = emailEl.value.trim();
    var phone = phoneEl.value.trim();
    var date  = dateEl.value;
    var time  = timeEl.value;
    var party = parseInt(partyEl.value, 10);
    var notes = (notesEl.value || '').trim();

    var dateFormatted = new Date(date + 'T12:00:00').toLocaleDateString(
      CONFIG.locale === 'fr' ? 'fr-CA' : 'en-CA',
      { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
    );

    var depositLabel = opts.depositAmount > 0
      ? fmt(opts.depositAmount) + (opts.depositPaid
          ? (CONFIG.locale === 'fr' ? ' (payé)' : ' (paid)')
          : (CONFIG.locale === 'fr' ? ' (à payer)' : ' (pending)'))
      : (CONFIG.locale === 'fr' ? 'Aucun' : 'None');

    var sharedFields = {
      reservation_id:    opts.resId,
      reservation_date:  dateFormatted,
      reservation_time:  time,
      party_size:        party + (CONFIG.locale === 'fr' ? ' convives' : ' guests'),
      deposit_amount:    depositLabel,
      notes:             notes || '—',
    };

    var logError = function (label, err) {
      console.error('EmailJS ' + label + ' send failed:', err);
    };

    if (CONFIG.emailjsCustomerTemplate) {
      var customerParams = {
        to_name:            name,
        to_email:           email,
        reservation_id:     sharedFields.reservation_id,
        reservation_date:   sharedFields.reservation_date,
        reservation_time:   sharedFields.reservation_time,
        party_size:         sharedFields.party_size,
        deposit_amount:     sharedFields.deposit_amount,
        notes:              sharedFields.notes
      };
      emailjs.send(CONFIG.emailjsServiceId, CONFIG.emailjsCustomerTemplate, customerParams)
        .catch(function (err) { logError('customer', err); });
    }

    if (CONFIG.emailjsRestaurantTemplate) {
      var restaurantParams = {
        customer_name:      name,
        customer_email:     email,
        customer_phone:     phone,
        reservation_id:     sharedFields.reservation_id,
        reservation_date:   sharedFields.reservation_date,
        reservation_time:   sharedFields.reservation_time,
        party_size:         sharedFields.party_size,
        deposit_amount:     sharedFields.deposit_amount,
        notes:              sharedFields.notes
      };
      emailjs.send(CONFIG.emailjsServiceId, CONFIG.emailjsRestaurantTemplate, restaurantParams)
        .catch(function (err) { logError('restaurant', err); });
    }
  }

  // ─── Success screen ──────────────────────────────────────────────────────

  function showSuccess(opts) {
    var bodyEl    = document.getElementById('res-form-body');
    var successEl = document.getElementById('res-success');
    if (!bodyEl || !successEl) return;

    var dateFormatted = new Date(dateEl.value + 'T12:00:00').toLocaleDateString(
      CONFIG.locale === 'fr' ? 'fr-CA' : 'en-CA',
      { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
    );

    document.getElementById('res-success-name').textContent  = nameEl.value.trim();
    document.getElementById('res-success-email').textContent = emailEl.value.trim();
    document.getElementById('res-success-date').textContent  = dateFormatted;
    document.getElementById('res-success-time').textContent  = timeEl.value;
    document.getElementById('res-success-party').textContent = partyEl.value + (CONFIG.locale === 'fr' ? ' convives' : ' guests');
    document.getElementById('res-success-id').textContent    = opts.resId;

    if (opts.depositAmount > 0) {
      var total = opts.depositAmount + opts.serviceFee;
      document.getElementById('res-success-deposit-row').style.display = 'block';
      document.getElementById('res-success-deposit').textContent = fmt(total);
    }

    if (opts.txnId) {
      document.getElementById('res-success-txn-row').style.display = 'block';
      document.getElementById('res-success-txn').textContent = opts.txnId;
    }

    var newBtn = document.getElementById('res-new-btn');
    if (newBtn) {
      newBtn.href = window.location.pathname;
    }

    bodyEl.style.display = 'none';
    successEl.classList.add('visible');
    successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Event handlers ──────────────────────────────────────────────────────

  function attachHandlers() {
    // Set min date to today — the 7 AM cutoff handles same-day blocking
    dateEl.min = new Date().toISOString().slice(0, 10);

    // Date change → populate time slots and check availability
    dateEl.addEventListener('change', function () {
      var slots = getTimeSlotsForDate(dateEl.value);
      var placeholder = CONFIG.locale === 'fr' ? '— Choisir une heure —' : '— Select a time —';
      timeEl.innerHTML = '<option value="">' + placeholder + '</option>' +
        slots.map(function (s) {
          var parts = s.split(':');
          var h = parseInt(parts[0], 10);
          var ampm = h >= 12 ? 'PM' : 'AM';
          var h12 = h > 12 ? h - 12 : h;
          var label = h12 + ':' + parts[1] + ' ' + ampm;
          return '<option value="' + s + '">' + label + '</option>';
        }).join('');
      timeEl.disabled = false;
      updateDepositInfo();
      updateSubmitZone();
    });

    // Time change → check availability
    timeEl.addEventListener('change', function () {
      checkAvailability();
      updateSubmitZone();
    });

    // Party size change → re-check availability display and deposit
    partyEl.addEventListener('change', function () {
      renderAvailability();
      updateDepositInfo();
      updateSubmitZone();
    });

    // Form field changes → update submit zone
    ['res-name', 'res-email', 'res-phone'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () {
        el.classList.remove('error');
        updateSubmitZone();
      });
    });

    // Auto-format phone
    phoneEl.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '');
      if (v.length <= 3)       this.value = v;
      else if (v.length <= 6)  this.value = v.slice(0, 3) + '-' + v.slice(3);
      else                     this.value = v.slice(0, 3) + '-' + v.slice(3, 6) + '-' + v.slice(6, 10);
    });

    // Book button (weekday, no deposit)
    bookBtn.addEventListener('click', function () {
      if (!isFormValid() || !hasAvailableSeats()) {
        highlightErrors();
        return;
      }
      bookBtn.disabled = true;
      bookBtn.textContent = CONFIG.locale === 'fr' ? 'Réservation en cours…' : 'Booking…';
      var resId = generateReservationId();
      submitReservation({
        resId: resId,
        depositAmount: 0,
        serviceFee: 0,
        depositPaid: false,
        txnId: null,
      });
    });
  }

  // ─── Wait for PayPal SDK ─────────────────────────────────────────────────

  function waitForPayPal(attempts) {
    if (window.paypal) { initPayPal(); return; }
    if (attempts <= 0) return;
    setTimeout(function () { waitForPayPal(attempts - 1); }, 300);
  }

  // ─── Init ────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    attachHandlers();
    updateSubmitZone();
    waitForPayPal(20);
  });
})();
